import { gql } from "graphql-tag"

const typeSpecialConditions = gql`
  type ProductSelection {
    key: String
    name: String
    priceList: String
  }

  type ProductSelections {
    items: [ProductSelection]
  }

  type PriceValue {
    currencyCode: String
    fractionDigits: Int
    centAmount: Int
    preciseAmount: Int
  }

  type ArticleDiscount {
    sku: String
    title: String
    altTitle: String
    amount: Float
    contents: String
    container: String
    quantity: Int
    price: PriceValue
    sellableInDecimals: Boolean
    validFrom: DateTime
    validTill: DateTime
  }
  type ArticleDiscounts {
    total: Int
    limit: Int
    offset: Int
    items: [ArticleDiscount]
  }

  type Query {
    customerProductSelections(customerNumber: String, locale: String): ProductSelections
    customerArticleDiscounts(
      customerNumber: String
      locale: String
      page: Int
      limit: Int
    ): ArticleDiscounts
  }
`

export { typeSpecialConditions }

export default typeSpecialConditions
